import EmailAddressAdd from "./EmailAddressAdd";
import { EmailAddressTable } from "./EmailAddressTable";
import { CommunicationBindingDelete } from "../CommunicationBindingDelete";
import { Heading } from "V2.0/common/heading";

export default function EmailAddressBinding(props) {
  const {
    isOpen,
    onClose,
    onBindingAdd,
    emailAddresses,
    communicationBinding,
    onBindingConfirmDelete,
    onBindingDelete,
    locked,
  } = props;

  return (
    <>
      <div className="flex flex-col w-1/3 mx-auto mt-4 p-4 gap-y-4 h-full min-h-0">
        <div className="w-full flex items-center justify-between">
          <Heading>Email Address</Heading>
          {!locked && (
            <EmailAddressAdd
              onEmailAddressAdd={onBindingAdd}
              emailAddresses={emailAddresses}
            />
          )}
        </div>
        <EmailAddressTable
          communicationBinding={communicationBinding}
          onItemDelete={onBindingDelete}
          showActions={!locked}
        />
      </div>
      {isOpen && !locked && (
        <CommunicationBindingDelete
          open={true}
          onClose={onClose}
          title="Remove Page"
          onDelete={onBindingConfirmDelete}
        />
      )}
    </>
  );
}
